import React, { useEffect, useMemo, useState } from "react";
import LiveIncidentsMap from "./components/LiveIncidentsMap";
import FiltersPanel from "./components/FiltersPanel";
import IncidentPopupModal from "./components/IncidentPopupModal";
import { mockIncidents } from "./mock/incidents.mock";
import { applyIncidentFilters } from "./utils/filters";
import { N550_INCIDENTS } from "../n550Map/mock/n550Incidents.mock";
import { consumeIncident } from "./utils/incidents.helpers";
import { useAuth } from "../../../contexts/AuthContext";

const INCIDENTS_BY_TENANT = {
  riga: mockIncidents.map(consumeIncident),
  galicia: N550_INCIDENTS.map(consumeIncident),
};

const LiveIncidents = () => {
  const { user } = useAuth();
  const tenant = user?.tenant ?? "riga";
  const [incidents, setIncidents] = useState(
    INCIDENTS_BY_TENANT[tenant] ?? INCIDENTS_BY_TENANT.riga
  );

  const [filters, setFilters] = useState({
    dateRange: [null, null],
    priorities: [],
    statuses: [],
    reporters: [],
    activeHistoric: "BOTH",
  });
  const [selectedId, setSelectedId] = useState(null);
  const selectedIncident = useMemo(
    () => incidents.find((i) => i.id === selectedId) || null,
    [incidents, selectedId]
  );

  const visibleIncidents = useMemo(
    () => applyIncidentFilters(incidents, filters),
    [incidents, filters]
  );

  useEffect(() => {
    setIncidents(INCIDENTS_BY_TENANT[tenant] ?? INCIDENTS_BY_TENANT.riga);
    setSelectedId(null);
  }, [tenant]);

  const handleMarkerClick = (id) => setSelectedId(id);

  const handleCloseModal = () => setSelectedId(null);

  const handleSaveIncident = (updated) => {
    setIncidents((prev) =>
      prev.map((i) => (i.id === updated.id ? { ...i, ...updated } : i))
    );
  };

  return (
    <div
      className="flex h-[calc(100dvh-172px)] w-full
  flex-col gap-3 overflow-hidden md:flex-row md:gap-4"
    >
      <div className="min-w-0 flex-1">
        <div className="h-full w-full">
          <LiveIncidentsMap
            incidents={visibleIncidents}
            onMarkerClick={handleMarkerClick}
            tenant={tenant}
          />
        </div>
      </div>

      <aside
        className="w-full shrink-0 overflow-hidden rounded-xl border border-gray-300 bg-white
        shadow-sm dark:border-white/40 dark:bg-navy-800 md:ml-3 md:w-[320px] "
      >
        <FiltersPanel
          filters={filters}
          setFilters={setFilters}
          tenant={tenant}
        />
      </aside>

      <IncidentPopupModal
        open={!!selectedIncident}
        incident={selectedIncident}
        onClose={handleCloseModal}
        onSave={handleSaveIncident}
      />
    </div>
  );
};

export default LiveIncidents;
